// A roster is the whole room as the server sees it right now. Anyone we still draw who is not in
// it left while we were not listening (inactive, or a dropped connection), so their `leave`
// never reached us. Returns the ids to remove and the roster entries of those we keep.
export function reconcileRoster(heldIds, peers) {
  const byId = new Map();
  for (const p of peers ?? []) if (p?.id) byId.set(p.id, p);
  const stale = [];
  const kept = [];
  for (const id of heldIds) {
    if (byId.has(id)) kept.push(byId.get(id));
    else stale.push(id);
  }
  return { stale, kept };
}
